
     
     
     document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.product-media-slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,

    pagination: {
      el: '.product-media-slider .swiper-pagination',
      clickable: true,
    },

    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
  });
});